import ThemeCard from "./ThemeCard";

export default function ThemeSelectionStep({ themes, form, updateField }) {
    return (
        <div className="wg-step-shell">
            <div className="wg-mode-bar">
                <div>
                    <h2 className="wg-section-title">AI Strategy</h2>
                    <p className="wg-section-subtitle">
                        Choose the visual direction for your AI-generated website. Nexus will still adapt
                        pages, CRM modules, images, and layout based on your industry.
                    </p>
                </div>
            </div>

            <div className="wg-block">
                <div className="wg-block-header">
                    <div>
                        <h3 className="wg-block-title">Choose Visual Direction</h3>
                        <p className="wg-block-subtitle">
                            Pick a starting style. Your generated website will still use industry-aware sections,
                            CRM-ready content, image planning, and optimization-ready structure.
                        </p>
                    </div>
                </div>

                <div className="wg-theme-grid">
                    {themes.map((theme) => (
                        <ThemeCard
                            key={theme.key}
                            theme={theme}
                            selected={form.themeKey === theme.key}
                            onClick={() => updateField("themeKey", theme.key)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}